import { usePublicFeatureFlags } from '@/shared/api/featureFlagsQueries'

export function useBlogFeatureFlag(): { enabled: boolean; isLoading: boolean } {
  const flagsQuery = usePublicFeatureFlags()
  return {
    enabled: flagsQuery.data?.find((row) => row.module_name === 'blog')?.enabled === true,
    isLoading: flagsQuery.isPending,
  }
}

export function useBlogEnabled(): boolean {
  return useBlogFeatureFlag().enabled
}
